import { type SeriesForPresentation } from '@mentimeter/http-clients';
import {
  getPaceDataRequest,
  getPaceDataResponse,
} from '@core-api/presentation/presentation/series/{series_id}/pace-data';
import { MentiError } from '@mentimeter/error-utils/error';

// For now we map back to the old format
export async function requestPaceData(
  seriesId: string,
  region: 'eu' | 'us',
): Promise<SeriesForPresentation> {
  const request = getPaceDataRequest({
    region,
    seriesId,
  });
  try {
    const response = await fetch(request);
    const { slidePaces = [], slideDeckPaces = [] } = await getPaceDataResponse(
      response,
      {
        enableStatusCheck: true,
      },
    );
    const stepsByKey = Object.fromEntries(
      slideDeckPaces.map(({ slidePublicKey, steps }) => [
        slidePublicKey,
        steps,
      ]),
    );
    // TODO refactor this to not use questions data, and rename linearNavigationSteps to steps
    return {
      questions: slidePaces.map(({ slidePublicKey }) => ({
        public_key: slidePublicKey,
        linearNavigationSteps: stepsByKey[slidePublicKey] ?? [],
      })),
    };
  } catch (error) {
    throw new MentiError('Failed to fetch pace data', {
      feature: 'presentation-state',
    });
  }
}
